<template>
  <div
    class="app__footer-wrapper"
    :class="{ 'app__footer-wrapper--fixed': appHeight < windowHeight }"
  >
    <div class="container">
      <footer class="app__footer">
        <div class="float-md-left footer__copy">
          &copy; {{ copyYear }}
          <a href="https://www.infarma.pl/" target="_blank">INFARMA</a>,
          <a :href="privacyPolicyUrl" target="_blank">Polityka Prywatności</a>
        </div>
        <div class="float-md-right footer__created-by">
          Wyprodukowane przez
          <a href="https://www.razdwaprojekt.pl/" target="_blank"
            >Raz Dwa Projekt</a
          >
        </div>
        &nbsp;
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFooter",
  data() {
    return {
      appHeight: 0,
      windowHeight: 0,
      interval: null
    };
  },
  computed: {
    copyYear() {
      const begin = 2020;
      const end = new Date().getFullYear();

      return begin != end ? `${begin}-${end}` : begin;
    },
    privacyPolicyUrl() {
      return `${process.env.VUE_APP_PRIVACY_POLICY_URL}`;
    }
  },
  mounted() {
    this.updateFooter();
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    resize() {
      this.windowHeight = window.innerHeight;
    },
    updateFooter() {
      this.$nextTick(function() {
        const app = document.querySelector(".app__body");
        this.$set(this, "appHeight", app.scrollHeight);
        this.interval = setTimeout(this.updateFooter, 300);
      });
    }
  }
};
</script>
